export default __webpack_public_path__ + "static/media/exportIcon.88f47595.svg";